import type { DeleteIssueUpdatesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

export const useDeleteIssueUpdatesTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.issueUpdate.delete.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.issueUpdate.register.queryKey(),
        });
      },
    }),
  });

  return {
    deleteIssueUpdates: async (variables: {
      ids: string[];
    }): Promise<DeleteIssueUpdatesMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result.affected_rows);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};

function mapTrpcResponseToGraphQL(
  affectedRows: number
): DeleteIssueUpdatesMutation {
  return {
    delete_issue_update: {
      __typename: 'issue_update_mutation_response',
      affected_rows: affectedRows,
    },
  };
}
